var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501,379V133c0-14.7-12.7-26.7-28.3-26.7H39.3c-15.6,0-28.3,12-28.3,26.7v246c0,14.7,12.7,26.7,28.3,26.7h433.4 C488.3,405.7,501,393.8,501,379z M35.5,379V133c0-0.9,1.5-2.2,3.8-2.2h433.4c2.4,0,3.8,1.4,3.8,2.2v246c0,0.9-1.5,2.2-3.8,2.2H39.3 C37,381.2,35.5,379.9,35.5,379z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.3,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.6,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.3,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.7,
    cy: 191.1,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.7,
    cy: 256,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.3,
    cy: 256,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 15.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.6,
    cy: 256,
    r: 15.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.3,240.7L381.3,240.7c-8.5,0-15.3,6.9-15.3,15.3c0,8.5,6.9,15.3,15.3,15.3l0,0c8.5,0,15.3-6.9,15.3-15.3 C396.6,247.5,389.8,240.7,381.3,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3,308.7H146.7c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h218.6c6.8,0,12.3-5.5,12.3-12.3S372.1,308.7,365.3,308.7 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/keyboardIcon.b69bb99e388d7b253886bbcb7782e14d.svg";
export { ForwardRef as ReactComponent };